import { render, staticRenderFns } from "./InstitutionEdit.vue?vue&type=template&id=6a110148&scoped=true&"
import script from "./InstitutionEdit.vue?vue&type=script&lang=js&"
export * from "./InstitutionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a110148",
  null
  
)

export default component.exports